import React, { useState, useEffect } from "react";
import { Box, Grid, Typography, Card, TextField, Button, Checkbox, FormControlLabel, MenuItem, IconButton } from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import CloseIcon from "@mui/icons-material/Close";

const OlympiadDeliverModal = ({ closePopup, modalData }) => {

     const isStudentRegistration = String(modalData?.registration_type) === "2";
    const isBookOrder = String(modalData?.registration_type) === "3";
    
    console.log(modalData, "lsbdkjasdbaskjdbasdkbaskjb")
    const [items, setItems] = useState({});
    const [selectedItems, setSelectedItems] = useState({});
    const [enteredItems, setEnteredItems] = useState({});
    const [step, setStep] = useState(1);
    const [trackingData, setTrackingData] = useState([]);
    const [attachmentData, setAttachmentData] = useState([]);
    const [previewImage, setPreviewImage] = useState(null);
    const [deletedAttachments, setDeletedAttachments] = useState([]);
    const [trackingForm, setTrackingForm] = useState({
        trackingNo: "",
        courier: "",
        dispatchDate: "",
        deliveryDate: "",
        parcelCount: "",
        status: "", // shipped / delivered
        proof: null
    });
    const [deliveryStatus, setDeliveryStatus] = useState(3);
    const [selectedStudyMaterial, setSelectedStudyMaterial] = useState({});
    const [enteredStudyMaterial, setEnteredStudyMaterial] = useState({});

    const handleStudyMaterialCheckbox = (classId, maxVal) => {
        setSelectedStudyMaterial((prev) => {
            const newVal = !prev[classId];
            if (newVal) {
                setEnteredStudyMaterial((p) => ({ ...p, [classId]: maxVal }));
            }
            return { ...prev, [classId]: newVal };
        });
    };

    const handleStudyMaterialCount = (classId, value, max) => {
        if (value === "") {
            setEnteredStudyMaterial((p) => ({ ...p, [classId]: "" }));
            return;
        }
        let v = Number(value);
        if (v < 0) v = 0;
        if (v > max) v = max;
        setEnteredStudyMaterial((p) => ({ ...p, [classId]: v }));
    };

    // ✅ Select All / Deselect All for Study Material
    // selectableItems: [{ key, remaining }]
    const handleSelectAllStudyMaterial = (selectableItems) => {
        if (!selectableItems || selectableItems.length === 0) return;

        const allSelected = selectableItems.every(({ key }) => !!selectedStudyMaterial[key]);

        if (allSelected) {
            setSelectedStudyMaterial((prev) => {
                const updated = { ...prev };
                selectableItems.forEach(({ key }) => {
                    updated[key] = false;
                });
                return updated;
            });
        } else {
            setSelectedStudyMaterial((prev) => {
                const updated = { ...prev };
                selectableItems.forEach(({ key }) => {
                    updated[key] = true;
                });
                return updated;
            });
            setEnteredStudyMaterial((prev) => {
                const updated = { ...prev };
                selectableItems.forEach(({ key, remaining }) => {
                    updated[key] = remaining;
                });
                return updated;
            });
        }
    };

    // ✅ Select All / Deselect All for the remaining (non Study-Material) shipment items
    // selectableItems: [{ item, remainingCount }]
    const handleSelectAllGeneralItems = (selectableItems) => {
        if (!selectableItems || selectableItems.length === 0) return;

        const allSelected = selectableItems.every(({ item }) => !!selectedItems[item.name]);

        if (allSelected) {
            setSelectedItems((prev) => {
                const updated = { ...prev };
                selectableItems.forEach(({ item }) => {
                    updated[item.name] = false;
                });
                return updated;
            });
        } else {
            setSelectedItems((prev) => {
                const updated = { ...prev };
                selectableItems.forEach(({ item }) => {
                    updated[item.name] = true;
                });
                return updated;
            });
            setEnteredItems((prev) => {
                const updated = { ...prev };
                selectableItems.forEach(({ item, remainingCount }) => {
                    if (item.id == 6) {
                        // "Others" is free text — mirror the same default the single checkbox uses
                        updated[item.name] = items[item.name] === 0 ? "" : items[item.name];
                    } else {
                        updated[item.name] = remainingCount;
                    }
                });
                return updated;
            });
        }
    };

    const handleTrackingChange = (key, value) => {

        if (key === "status") {
            if (value === "shipped") setDeliveryStatus(3);
            else if (value === "delivered") setDeliveryStatus(4);
        }
        setTrackingForm((prev) => {
            let updated = { ...prev, [key]: value };

            return updated;
        });
    };

    useEffect(() => {
        if (trackingForm.dispatchDate) {
            const dispatch = new Date(trackingForm.dispatchDate);

            const estimated = new Date(dispatch);
            estimated.setDate(dispatch.getDate() + 7);

            const formatted = estimated.toISOString().split("T")[0];

            setTrackingForm((prev) => ({
                ...prev,
                deliveryDate: formatted
            }));
        }
    }, [trackingForm.dispatchDate]);

    const handleRemoveAttachment = (index) => {
        const isSuccess = window.confirm("Are you sure you want to delete this image?");

        if (!isSuccess) return;

        setAttachmentData((prev) => {
            const removed = prev[index];

            if (!removed.file) {
                setDeletedAttachments((d) => [...d, removed]);
            }

            return prev.filter((_, i) => i !== index);
        });
    };

    const handleChange = (key, value) => {
        if (key === "Others") {
            setEnteredItems((prev) => ({
                ...prev,
                [key]: value,
            }));
            return;
        }

        const maxValue = items[key] || 0;

        if (value === "") {
            setEnteredItems((prev) => ({
                ...prev,
                [key]: "",
            }));
            return;
        }

        let finalValue = Number(value);

        if (finalValue < 0) finalValue = 0;
        if (finalValue > maxValue) finalValue = maxValue;

        setEnteredItems((prev) => ({
            ...prev,
            [key]: finalValue,
        }));
    };

    const handleCheckboxChange = (name) => {
        setSelectedItems((prev) => {
            const newValue = !prev[name];

            if (newValue) {
                setEnteredItems((prevEntered) => ({
                    ...prevEntered,
                    [name]: items[name] === 0 ? "" : items[name]
                }));
            }

            return {
                ...prev,
                [name]: newValue,
            };
        });
    };

    const submitFinalTracking = async () => {
        console.log(trackingForm, "lnsdlnhaasdhASHaso")
        if (!trackingForm.trackingNo?.trim()) {
            window.alert("Tracking Number Must be entered");
            return;
        }
        if (!trackingForm.courier?.trim()) {
            window.alert("Enter Courier");
            return;
        }
        if (!trackingForm.status?.trim()) {
            window.alert("Please Fill Delivery Status");
            return;
        }
        if (!trackingForm.dispatchDate?.trim()) {
            window.alert("Please Fill Dispatch Date");
            return;
        }
        if (!trackingForm.deliveryDate?.trim()) {
            window.alert("Please Fill Delivery Date");
            return;
        }
        if (!trackingForm.parcelCount?.trim()) {
            window.alert("Enter Parcel Count");
            return;
        }
        if (attachmentData?.length <= 0) {
            window.alert("Please Uplaoad Attachemnt");
            return;
        }

        // ✅ "Fully shipped" must mean EVERY required class/subject (Study Material)
        // and EVERY required item is now covered — combining what was already
        // shipped before with what's in this submission. Checking only the rows
        // included in trackingData is wrong: if some classes/subjects (or items)
        // were left unselected, they're silently skipped and the check would
        // pass even though the order isn't actually complete.
        const enteredSMByKey = {};
        const enteredGeneralByName = {};
        trackingData.forEach((item) => {
            if (item.id === 1) {
                const key = `${item.classId}_${item.subjectId}`;
                enteredSMByKey[key] = Number(item.count || 0);
            } else if (item.name !== "Others") {
                enteredGeneralByName[item.name] = Number(item.count || 0);
            }
        });

        const allSMFullyShipped = isStudentRegistration
            ? true
            : (modalData?.lineItems || []).every((lineItem) => {
                const key = `${lineItem.classId}_${lineItem.subjectId}`;
                const alreadyShipped = getAlreadyShippedSMCount(lineItem.classId, lineItem.subjectId);
                const newlyShipped = enteredSMByKey[key] || 0;
                const total = lineItem.study_material || 0;
                return alreadyShipped + newlyShipped >= total;
            });

        // "Others" (id 6) has no fixed total, so it's excluded from completeness —
        // it's an optional extra, never something that blocks "fully shipped".
        const requiredGeneralItems = (modalData?.shipmentItemes?.itemsNameWithId || [])
            .filter((it) => it.id != 1 && it.id != 6 && (!isBookOrder || it.id == 6));

        const allGeneralFullyShipped = requiredGeneralItems.every((itemDef) => {
            const alreadyShipped = getAlreadyShippedCount(itemDef.id);
            const newlyShipped = enteredGeneralByName[itemDef.name] || 0;
            const total = modalData?.shipmentItemes?.totalStudent || 0;
            return alreadyShipped + newlyShipped >= total;
        });

        const allFullyShipped = allSMFullyShipped && allGeneralFullyShipped;

        let deliveryStatus;

        if (allFullyShipped) {
            deliveryStatus = trackingForm.status === "delivered" ? 4 : 3;
        } else {
            if (trackingForm.status === "shipped") {
                deliveryStatus = 3;
            } else if (trackingForm.status === "delivered") {
                deliveryStatus = 8;
            }
        }

        const formData = new FormData();

        attachmentData.forEach((fileObj) => {
            console.log(fileObj, "fileObj")
            if (fileObj.file instanceof File) {
                formData.append("files", fileObj.file);
            }
        });

        formData.append("regId", modalData?.regId);
        formData.append("deliveryStatus", deliveryStatus);

        formData.append("items", JSON.stringify(trackingData));
        formData.append("tracking", JSON.stringify(trackingForm));

        try {
            const res = await window.Platform.database.createShipment(formData);

            if (res.status) {
                window.NotificationUtils.showSuccess(res?.message || "Successfully Done");
                closePopup();
            } else {
                window.NotificationUtils.showError(res?.message || "Something went wrong");
            }
        } catch (err) {
            console.error(err);
            window.NotificationUtils.showError("API Failed");
        }
    };

    useEffect(() => {
        return () => {
            attachmentData.forEach(att => {
                if (att.file) URL.revokeObjectURL(att.preview);
            });
        };
    }, [attachmentData]);


    const getShippedCounts = () => {
        const shippedMap = {};

        modalData?.shipmentDetails?.forEach((shipment) => {
            shipment?.items?.forEach((item) => {
                if (!shippedMap[item.name]) {
                    shippedMap[item.name] = 0;
                }

                // ignore "Others" (text based)
                if (!isNaN(item.count)) {
                    shippedMap[item.name] += Number(item.count);
                }
            });
        });

        return shippedMap;
    };


    const formatDate = (date) => {
        if (!date) return "-";

        return new Date(date).toLocaleDateString("en-IN", {
            day: "2-digit",
            month: "short",
            year: "numeric"
        });
    };

    const getAlreadyShippedCount = (itemId) => {
        let total = 0;
        modalData?.shipmentDetails?.forEach((shipment) => {
            shipment?.items?.forEach((item) => {
                if (String(item.item_id) === String(itemId)) {
                    total += Number(item.count || 0);
                }
            });
        });
        return total;
    };

    // ✅ Study Material must be tracked per class + subject, not just by item_id.
    // Requires the backend to persist classId/subjectId on each stored shipment
    // item (see note above) — returns 0 for that class/subject if it isn't present yet.
    const getAlreadyShippedSMCount = (classId, subjectId) => {
        let total = 0;
        modalData?.shipmentDetails?.forEach((shipment) => {
            shipment?.items?.forEach((item) => {
                if (
                    String(item.item_id) === "1" &&
                    String(item.classId) === String(classId) &&
                    String(item.subjectId) === String(subjectId)
                ) {
                    total += Number(item.count || 0);
                }
            });
        });
        return total;
    };

    useEffect(() => {
        if (modalData?.shipmentItemes?.itemsNameWithId) {
            const initialItems = {};
            modalData.shipmentItemes.itemsNameWithId.forEach((item) => {
                const shipped = getAlreadyShippedCount(item.id);
                if (item.id == 1) {
                    if (String(modalData?.registration_type) === "3") {
                        return null;
                    }
                    // SM handled separately
                } else if (item.id == 6) {
                    initialItems[item.name] = 0;
                } else {
                    const total = modalData?.shipmentItemes?.totalStudent || 0;
                    initialItems[item.name] = Math.max(0, total - shipped);
                }
            });
            setItems(initialItems);
        }
    }, [modalData]);

    const handleAddTracking = () => {
        const selectedKeys = Object.keys(selectedItems).filter((key) => selectedItems[key]);
        const selectedSMKeys = Object.keys(selectedStudyMaterial).filter(
            (key) => selectedStudyMaterial[key]
        );

        if (selectedKeys.length === 0 && selectedSMKeys.length === 0) {
            alert("Please select at least one item");
            return;
        }

        // Validate non-SM items
        for (let key of selectedKeys) {
            const value = enteredItems[key];
            const isOthers = modalData?.shipmentItemes?.itemsNameWithId?.find(
                (i) => i.name === key
            )?.id === 6;
            if (isOthers) {
                if (!value || value.trim() === "") { alert("Please enter value for Others"); return; }
            } else {
                if (!value || Number(value) <= 0) { alert(`Please enter valid count for ${key}`); return; }
            }
        }

        // ✅ use SM_classId_subjectId key
        for (let key of selectedSMKeys) {
            const value = enteredStudyMaterial[key];
            if (!value || Number(value) <= 0) {
                const cls = modalData?.lineItems?.find(
                    (l) => `SM_${l.classId}_${l.subjectId}` === key
                );
                alert(`Please enter valid count for Study Material - ${cls?.className} - ${cls?.subjectName || key}`);
                return;
            }
        }

        // Build regular items
        const regularData = selectedKeys.map((key) => {
            const itemObj = modalData?.shipmentItemes?.itemsNameWithId?.find((i) => i.name === key);
            return {
                id: itemObj?.id,
                name: key,
                count: key === "Others" ? enteredItems[key] || "" : enteredItems[key] || 0
            };
        });

        // ✅ use SM_classId_subjectId key
        const smData = selectedSMKeys.map((key) => {
            const lineItem = modalData?.lineItems?.find(
                (l) => `SM_${l.classId}_${l.subjectId}` === key
            );
            return {
                id: 1,
                name: "Study Material",
                className: lineItem?.className,
                classId: lineItem?.classId,
                subjectId: lineItem?.subjectId,
                subjectName: lineItem?.subjectName,
                count: enteredStudyMaterial[key] || 0
            };
        });

        setTrackingData([...smData, ...regularData]);
        setStep(2);
    };


    return (
        <Box p={3}>
            <IconButton
                onClick={closePopup}
                sx={{
                    position: "absolute",
                    right: 8,
                    top: 8
                }}
            >
                <CloseIcon />
            </IconButton>
            {step == 1 ? <>
                <div style={{ display: "flex", justifyContent: "center", alignItems: "center", fontSize: "20px", fontWeight: "600", marginBottom: "10px" }}>
                    Item Delivery ({modalData?.rno_id})
                </div>
                <Card sx={{ p: 3, mb: 3, background: "#e8f5e9" }}>
                    <Grid container spacing={2}>
                        <Grid item xs={12} md={6}>
                            <p> School name: -   ({modalData?.partyId || ""}) {modalData?.schoolName || "N/A"}</p>
                        </Grid>

                        <Grid item xs={12} md={6}>
                            <p> RM name: -  ({modalData?.userId || ""}) {modalData?.userName || "N/A"}</p>
                        </Grid>
                        <Grid item xs={12} md={6}>
                            <p> Date Of Olympiad: -   {formatDate(modalData?.olympiad_date)}</p>
                        </Grid>

                        <Grid item xs={12} md={6}>
                            <p> Total Students: - {modalData?.shipmentItemes?.totalStudent || 0}</p>
                        </Grid>
                        <Grid item xs={12} md={6}>
                            <p> Medium: -   {modalData?.reg_medium_name || "N/A"}</p>
                        </Grid>

                        <Grid item xs={12} md={6}>
                            <p> Total Books: -  {modalData?.shipmentItemes?.totalStudyMaterial || 0}</p>
                        </Grid>
                        <Grid item xs={12} md={12}>
                            <p>
                                Classes Opted: -
                                {
                                    modalData?.lineItems?.length
                                        ? [...new Set(modalData.lineItems.map(item => item.className))]
                                            .sort((a, b) => {
                                                const numA = parseInt(a.replace(/\D/g, ""));
                                                const numB = parseInt(b.replace(/\D/g, ""));
                                                return numA - numB;
                                            })
                                            .join(", ")
                                        : "N/A"
                                }
                            </p>
                        </Grid>

                        <Grid item xs={12} md={12}>
                            <p>
                                Subjects Opted: -
                                {
                                    modalData?.lineItems?.length
                                        ? [...new Set(modalData.lineItems.map(item => item.subjectName))].join(", ")
                                        : "N/A"
                                }
                            </p>
                        </Grid>
                    </Grid>
                </Card>

                {/* ✅ Select All control for the remaining (non Study-Material) shipment items */}
                {/* {(() => {
                    const generalSelectableItems = (modalData?.shipmentItemes?.itemsNameWithId || [])
                        .filter((item) => item.id != 1 && (!isBookOrder || item.id == 6))
                        .map((item) => {
                            const alreadyShipped = getAlreadyShippedCount(item.id);
                            const totalCount = item.id == 6 ? 0 : modalData?.shipmentItemes?.totalStudent || 0;
                            const remainingCount = Math.max(0, totalCount - alreadyShipped);
                            return { item, remainingCount };
                        })
                        .filter(({ item, remainingCount }) => remainingCount > 0 || item.id == 6);

                    if (generalSelectableItems.length === 0) return null;

                    const allGeneralSelected = generalSelectableItems.every(
                        ({ item }) => !!selectedItems[item.name]
                    );
                    const someGeneralSelected = generalSelectableItems.some(
                        ({ item }) => !!selectedItems[item.name]
                    );

                    return (
                        <Box display="flex" justifyContent="flex-end" mb={1}>
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        checked={allGeneralSelected}
                                        indeterminate={!allGeneralSelected && someGeneralSelected}
                                        onChange={() => handleSelectAllGeneralItems(generalSelectableItems)}
                                    />
                                }
                                label={<Typography variant="body2" fontWeight={600}>Select All Items</Typography>}
                            />
                        </Box>
                    );
                })()} */}

                <Grid container spacing={2}>
                    {modalData?.shipmentItemes?.itemsNameWithId?.map((item) => {
                        // ✅ Special handling for Study Material (id == 1)
                        if (item.id == 1) {
                            if (isStudentRegistration) {
                                return null;
                            }

                            // Precompute shipped/remaining for every class+subject line item
                            // (kept as a plain array so both the "Select All" control and
                            // the individual rows read from the same source of truth).
                            const smLineItemsWithRemaining = (modalData?.lineItems || []).map((lineItem) => {
                                const key = `SM_${lineItem.classId}_${lineItem.subjectId}`;
                                const total = lineItem.study_material || 0;
                                const shipped = getAlreadyShippedSMCount(lineItem.classId, lineItem.subjectId);
                                const remaining = Math.max(0, total - shipped);

                                return { lineItem, key, total, shipped, remaining };
                            });

                            // Only items that still have something left to ship are selectable
                            const selectableSMItems = smLineItemsWithRemaining.filter((r) => r.remaining > 0);

                            const allSMSelected =
                                selectableSMItems.length > 0 &&
                                selectableSMItems.every((r) => !!selectedStudyMaterial[r.key]);
                            const someSMSelected = selectableSMItems.some((r) => !!selectedStudyMaterial[r.key]);

                            return (
                                <Grid item xs={12} sm={6} md={4} key={item.id}>
                                    <Card sx={{ p: 2 }}>
                                        <Box display="flex" alignItems="center" justifyContent="space-between">
                                            <Typography fontWeight="bold">{item.name}</Typography>
                                            {selectableSMItems.length > 0 && (
                                                <FormControlLabel
                                                    sx={{ mr: 0 }}
                                                    control={
                                                        <Checkbox
                                                            size="small"
                                                            checked={allSMSelected}
                                                            indeterminate={!allSMSelected && someSMSelected}
                                                            onChange={() => handleSelectAllStudyMaterial(selectableSMItems)}
                                                        />
                                                    }
                                                    label={<Typography variant="body2">Select All</Typography>}
                                                />
                                            )}
                                        </Box>
                                        {smLineItemsWithRemaining.map(({ lineItem, key, total, shipped, remaining }) => {
                                            return (
                                                <Box key={key} mt={1}>
                                                    <FormControlLabel
                                                        control={
                                                            <Checkbox
                                                                checked={!!selectedStudyMaterial[key]}
                                                                onChange={() =>
                                                                    remaining > 0
                                                                        ? handleStudyMaterialCheckbox(key, remaining)
                                                                        : null
                                                                }
                                                                disabled={remaining === 0}
                                                            />
                                                        }
                                                        label={
                                                            <span>
                                                                {lineItem.className} - {lineItem.subjectName} ({total})
                                                                {shipped > 0 && (
                                                                    <span style={{ color: "#f57c00", fontSize: "12px", marginLeft: "6px" }}>
                                                                        [{shipped} shipped]
                                                                    </span>
                                                                )}
                                                            </span>
                                                        }
                                                    />
                                                    {remaining === 0 ? (
                                                        <Typography
                                                            variant="caption"
                                                            sx={{
                                                                color: "green",
                                                                display: "block",
                                                                ml: 1,
                                                                fontWeight: 600
                                                            }}
                                                        >
                                                            ✅ Already Fully Shipped
                                                        </Typography>
                                                    ) : (
                                                        selectedStudyMaterial[key] && (
                                                            <TextField
                                                                label="Enter Delivery Count"
                                                                type="number"
                                                                size="small"
                                                                fullWidth
                                                                inputProps={{ min: 0, max: remaining }}
                                                                onWheel={(e) => e.target.blur()}
                                                                value={enteredStudyMaterial[key] ?? ""}
                                                                onChange={(e) =>
                                                                    handleStudyMaterialCount(key, e.target.value, remaining)
                                                                }
                                                                sx={{ mt: 1 }}
                                                            />
                                                        )
                                                    )}
                                                </Box>
                                            );
                                        })}
                                    </Card>
                                </Grid>
                            );
                        }

                        // All other items remain unchanged
                        if (isBookOrder && item.id !== 1 && item.id !== 6) {
                            return null;
                        }
                        const alreadyShipped = getAlreadyShippedCount(item.id);
                        const totalCount = item.id == 6 ? 0 : modalData?.shipmentItemes?.totalStudent || 0;
                        const remainingCount = Math.max(0, totalCount - alreadyShipped);

                        return (
                            <Grid item xs={12} sm={6} md={4} key={item.id}>
                                <Card sx={{ p: 2 }}>
                                    <Typography fontWeight="bold">{item.name}</Typography>
                                    <FormControlLabel
                                        control={
                                            <Checkbox
                                                checked={!!selectedItems[item.name]}
                                                onChange={() =>
                                                    remainingCount > 0 || item.id == 6
                                                        ? handleCheckboxChange(item.name)
                                                        : null
                                                }
                                                disabled={remainingCount === 0 && item.id !== 6}
                                            />
                                        }
                                        label={
                                            <span>
                                                {item.name} ({item.id == 6 ? 0 : totalCount})
                                                {alreadyShipped > 0 && item.id !== 6 && (
                                                    <span style={{ color: "#f57c00", fontSize: "12px", marginLeft: "6px" }}>
                                                        [{alreadyShipped} shipped]
                                                    </span>
                                                )}
                                            </span>
                                        }
                                    />
                                    {remainingCount === 0 && item.id !== 6 ? (
                                        <Typography
                                            variant="caption"
                                            sx={{ color: "green", display: "block", ml: 1, fontWeight: 600 }}
                                        >
                                            ✅ Already Fully Shipped
                                        </Typography>
                                    ) : (
                                        selectedItems[item.name] && (
                                            <TextField
                                                label={item.id == 6 ? "Enter Item (e.g. Chalk 12)" : "Enter Delivery Count"}
                                                type={item.id == 6 ? "text" : "number"}
                                                size="small"
                                                fullWidth
                                                inputProps={
                                                    item.id == 6
                                                        ? {}
                                                        : { min: 0, max: remainingCount }
                                                }
                                                onWheel={(e) => e.target.blur()}
                                                value={enteredItems[item.name] ?? ""}
                                                onChange={(e) => handleChange(item.name, e.target.value)}
                                                sx={{ mt: 1 }}
                                            />
                                        )
                                    )}
                                </Card>
                            </Grid>
                        );
                    })}
                </Grid>
                <Box mt={3} display="flex" gap={2}>
                    <Button variant="contained" onClick={handleAddTracking} alignItems="center">
                        Add Tracking Detail
                    </Button>
                </Box>
            </>
                :
                <Box p={3}>
                    <Typography variant="h6" mb={2}>
                        Update Tracking Details
                    </Typography>
                    <Grid container spacing={2}>
                        <Grid item xs={12} md={6}>
                            <TextField
                                label="Tracking No."
                                fullWidth
                                size="small"
                                value={trackingForm.trackingNo}
                                onChange={(e) => handleTrackingChange("trackingNo", e.target.value)}
                            />
                        </Grid>
                        <Grid item xs={12} md={6}>
                            <TextField
                                label="Courier"
                                fullWidth
                                size="small"
                                value={trackingForm.courier}
                                onChange={(e) => handleTrackingChange("courier", e.target.value)}
                            />
                        </Grid>
                        <Grid item xs={12} md={12}>
                            <TextField
                                label="Delivery Status"
                                select
                                fullWidth
                                size="small"
                                value={trackingForm.status}
                                onChange={(e) => { handleTrackingChange("status", e.target.value) }}
                            >
                                {modalData?.status != 8 &&<MenuItem value="shipped">Shipped</MenuItem>}
                                <MenuItem value="delivered">Delivered</MenuItem>
                            </TextField>
                        </Grid>
                        <Grid item xs={12} md={6}>
                            <TextField
                                label="Dispatch Date"
                                type="date"
                                fullWidth
                                size="small"
                                InputLabelProps={{ shrink: true }}
                                value={trackingForm.dispatchDate}
                                onChange={(e) => handleTrackingChange("dispatchDate", e.target.value)}
                            />
                        </Grid>
                        <Grid item xs={12} md={6}>
                            <TextField
                                label="Estimated Delivery Date"
                                type="date"
                                fullWidth
                                size="small"
                                InputLabelProps={{ shrink: true }}
                                inputProps={{
                                    min: trackingForm.dispatchDate || new Date().toISOString().split("T")[0]
                                }}
                                value={trackingForm.deliveryDate}
                                onChange={(e) => {
                                    const value = e.target.value;

                                    if (trackingForm.dispatchDate && value < trackingForm.dispatchDate) {
                                        alert("Delivery date cannot be before dispatch date");
                                        return;
                                    }

                                    handleTrackingChange("deliveryDate", value);
                                }}
                            />
                        </Grid>
                        <Grid item xs={12} md={6}>
                            <TextField
                                label="Parcel Count"
                                type="number"
                                onWheel={(e) => e.target.blur()}
                                fullWidth
                                size="small"
                                value={trackingForm.parcelCount}
                                onChange={(e) => handleTrackingChange("parcelCount", e.target.value)}
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <Button variant="outlined" component="label">
                                Upload Attachment
                                <input
                                    type="file"
                                    multiple
                                    hidden
                                    onChange={(e) => {
                                        const files = Array.from(e.target.files);

                                        const mappedFiles = files.map((file) => ({
                                            file: file,
                                            name: file.name,
                                            path: `${window.Platform.database.funcForBaseURL()}/file/${file.name}`
                                        }));

                                        setAttachmentData((prev) => [...prev, ...mappedFiles]);
                                    }}
                                />
                            </Button>
                            {attachmentData.length > 0 && (
                                <Box mt={1}>
                                    <Grid container spacing={2} mt={1}>
                                        {attachmentData.map((att, i) => {
                                            const imageUrl = att.file
                                                ? URL.createObjectURL(att.file) // new upload preview
                                                : `${window.Platform.database.funcForBaseURL()}/file/${att.name}`;

                                            return (
                                                <Grid item xs={3} key={i}> {/* 12/4 = 3 per row */}
                                                    <Box textAlign="center">
                                                        <DeleteIcon
                                                            onClick={() => handleRemoveAttachment(i)}
                                                            style={{
                                                                position: "absolute",
                                                                cursor: "pointer",
                                                                color: "#d90000",
                                                                background: "#fff",
                                                                borderRadius: "50%"
                                                            }}
                                                        />
                                                        <img
                                                            src={imageUrl}
                                                            alt={att.name}
                                                            onClick={() => setPreviewImage(imageUrl)}
                                                            style={{
                                                                width: "100%",
                                                                height: "120px",
                                                                objectFit: "cover",
                                                                borderRadius: "8px",
                                                                cursor: "pointer",
                                                                border: "1px solid #ccc"
                                                            }}
                                                        />
                                                        <Typography variant="caption">
                                                            {att.name}
                                                        </Typography>
                                                    </Box>
                                                </Grid>
                                            );
                                        })}
                                    </Grid>
                                </Box>
                            )}
                        </Grid>
                    </Grid>
                    <Box mt={3} display="flex" gap={2}>
                        <Button variant="outlined" onClick={() => setStep(1)}>
                            Back
                        </Button>
                        <Button
                            variant="contained"
                            color="success"
                            onClick={() => { submitFinalTracking() }}
                        >
                            Submit
                        </Button>
                    </Box>
                </Box>
            }
            <Box display="flex" justifyContent="center" mt={2}>
                <Typography fontWeight="bold">
                    Step {step} of 2
                </Typography>
            </Box>
        </Box>
    );
};

export default OlympiadDeliverModal;